import createAction from './';

export const CLEAR_MODAL_QUEUE = createAction('CLEAR_MODAL_QUEUE');

export const clearModalQueue = () => ({ type: CLEAR_MODAL_QUEUE });
